import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { CsvService, License, Course } from '../../core';
import { LicenseSessionsService } from '../services/license-sessions.service';

@Component({
  selector: 'lms-license-report',
  templateUrl: './license-report.component.html',
  styleUrls: ['./license-report.component.scss']
})
export class LicenseReportComponent implements OnInit {
  public licenseReportListId = 'LICENSE_REPORT_LIST';
  reportData: any;
  public filters: Map<string, string>;
  public durationOffset = new Date(0).getTimezoneOffset() * 60000;
  public license: License;
  public course: Course;

  constructor(
    public csvService: CsvService,
    public licenseSessionsService: LicenseSessionsService,
    public route: ActivatedRoute,
    public location: Location,
    public translate: TranslateService,
    public titleService: Title
  ) {}

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.license = data.license;
      this.course = data.course;
    });
  }

  setCollection(sessions) {
    this.reportData = sessions;
  }

  goBack(): void {
    this.location.back();
  }

  isPrintable(field) {
    const fieldsCSV = [
      'values',
      'userEmail',
      'startDate',
      'endDate',
      'durationSeconds',
      'accumulatedPoints',
      'accumulatedNegativePoints',
      'turn',
      'gameProgress'
    ];
    return fieldsCSV.indexOf(field) >= 0;
  }

  download() {
    const data = this.licenseSessionsService.getAttr('reportData').data;
    if (data.length) {
      const valueFields = Object.keys(data[0]['values']).filter(this.isPrintable);
      const fields = Object.keys(data[0]).filter(this.isPrintable);
      const orderedData = [];
      data.forEach((elem, index) => {
        orderedData[index] = {};
        fields.forEach((field) => {
          if (field === 'values') {
            valueFields.forEach((valueField) => {
              orderedData[index]['v-' + valueField] = elem['values'][valueField];
            });
          } else {
            orderedData[index][field] = elem[field];
          }
        });
      });
      this.csvService.dataToCsv(orderedData, 'csvFile', {
        showLabels: true,
        headers: Object.keys(orderedData[0])
      });
    }
  }
}
